import { render } from "./UpInfo.vue?vue&type=template&id=aa572650&scoped=true"
import script from "./UpInfo.vue?vue&type=script&lang=js"
export * from "./UpInfo.vue?vue&type=script&lang=js"

import "./UpInfo.vue?vue&type=style&index=0&id=aa572650&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa572650"]])

export default __exports__